import { ReactSDKClient } from '@optimizely/react-sdk';
import {
    createOptimizelyReactSDKClient,
    OptimizelyDataFile
} from './optimizely';

let optimizelyReactSDKClient: ReactSDKClient;

// reuse optimizely client instance on client-side to persist userId, forced variations, and forced features
export const getOptimizelyReactSDKClient = (
    datafile: OptimizelyDataFile
): ReactSDKClient => {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) {
        return createOptimizelyReactSDKClient(datafile);
    }

    if (!optimizelyReactSDKClient) {
        optimizelyReactSDKClient = createOptimizelyReactSDKClient(datafile);
    }

    return optimizelyReactSDKClient;
};
